import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

const CardWithoutData = ({ title }) => {
    return (
        <React.Fragment>
            <Card className='card-height-100'>
                {title ? (
                    <CardHeader className='p-2'>
                        <h5 className="card-title mb-0">{title}</h5>
                    </CardHeader>
                ) : null}
                <CardBody style={{ paddingTop: '0px' }}>
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <div className="text-center">
                            <div className="avatar-md">
                                <span className="avatar-title bg-info-subtle rounded-circle fs-1">
                                    <i className="ri-eye-close-fill text-info"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <p className="fs-16 lh-base text-center">Sin resultados disponibles.</p>
                    <p className="text-center">No se encontraron datos. Por favor, intente nuevamente o contacte a mesa de ayuda si el problema persiste.</p>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default CardWithoutData;
